import { render } from "./payment_success.vue?vue&type=template&id=1852210f&scoped=true"
import script from "./payment_success.vue?vue&type=script&lang=js"
export * from "./payment_success.vue?vue&type=script&lang=js"

import "./payment_success.vue?vue&type=style&index=0&id=1852210f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1852210f"],['__file',"src/views/account_center/components/payment_success.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1852210f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1852210f', __exports__)) {
    api.reload('1852210f', __exports__)
  }
  
  module.hot.accept("./payment_success.vue?vue&type=template&id=1852210f&scoped=true", () => {
    api.rerender('1852210f', render)
  })

}


export default __exports__